<template>
  <!-- 客服和电话悬浮按钮 -->
  <div
    class="sidemenu"
    id="moveDiv"
    @mousedown="down"
    @touchstart="down"
    @mousemove="move"
    @touchmove="move"
    @mouseup="end"
    @touchend="end"
  >
    <div class="consult1" @click.stop="goconsult(1)">
      <img src="~@/assets/image/common/phone.webp" alt="" />
    </div>
    <div class="consult2" @click.stop="goconsult(2)">
      <img src="~@/assets/image/common/kefu.png" alt="" />
    </div>
  </div>
</template>

<script>
let moveDiv
export default {
  data() {
    return {
      flags: false,
      position: { x: 0, y: 0 },
      nx: '',
      ny: '',
      dx: '',
      dy: '',
      xPum: '',
      yPum: '',
      diffx: '',
      innerWidth: '',
      firstTime: '',
      lastTime: ''
    }
  },
  mounted() {
    this.innerWidth = window.screen.width
    const divWidth = document.querySelector('.sidemenu').offsetWidth
    this.diffx = innerWidth - divWidth
  },
  methods: {
    // 获取客服联系电话
    goconsult(index) {
      if (index === 1) {
        const userInfo = this.$utils.getUserInfo()
        let phone = ''
        if (userInfo.isMGU == 'Y') {
          phone = '400-114-9606'
        } else if (userInfo.payorLine) {
          phone = userInfo.payorLine
        } else {
          phone = '400-880-8820'
        }
        window.location.href = `tel:${phone}`
      } else {
        this.$apis.getUdeskUrl().then((res) => {
          if (res.data.returnCode == '0000') {
            window.location.href = res.data.content
          }
        })
      }
    },
    // 按下悬浮框
    down() {
      this.firstTime = new Date().getTime()
      this.flags = true
      let touch
      if (event.touches) {
        touch = event.touches[0]
      } else {
        touch = event
      }
      this.position.x = touch.clientX
      this.position.y = touch.clientY
      this.dx = moveDiv.offsetLeft
      this.dy = moveDiv.offsetTop
    },
    // 移动悬浮框
    move() {
      if (this.flags) {
        let touch

        if (event.touches) {
          touch = event.touches[0]
        } else {
          touch = event
        }
        this.nx = touch.clientX - this.position.x
        this.ny = touch.clientY - this.position.y
        this.xPum = this.dx + this.nx
        this.yPum = this.dy + this.ny
        console.log(this.nx, this.ny)
        if (parseInt(this.nx) > 2 || parseInt(this.ny) > 2) {
          moveDiv.style.left = this.xPum + 'px'
          moveDiv.style.top = this.yPum + 'px'
          moveDiv.style.right = 'auto'
          moveDiv.style.bottom = 'auto'
        }
        //阻止页面的滑动默认事件
        document.addEventListener(
          'touchmove',
          function (event) {
            if (this.flags === true) {
              event.preventDefault()
            } else {
              return true
            }
          },
          { passive: false }
        )
      }
    },
    //鼠标释放时候的函数
    end() {
      this.lastTime = new Date().getTime()
      if (this.lastTime - this.firstTime > 500) {
        this.flags = false
        if (parseInt(moveDiv.style.left) > this.innerWidth / 2) {
          moveDiv.style.left = this.diffx + 'px'
        } else {
          moveDiv.style.left = '0px'
        }
        moveDiv.style.right = 'auto'
        moveDiv.style.bottom = 'auto'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidemenu {
  position: fixed;
  right: 0;
  bottom: 167px;
  z-index: 2;
  div {
    width: 45px;
    height: 38px;
    margin-bottom: 10px;
    padding-left: 7px;
    img {
      width: 38px;
      height: 38px;
      object-fit: cover;
      border-radius: 5px;
    }
    &.consult1 img {
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    }
    &.consult2 img {
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
